import { z } from 'zod'
import { objectToCamel } from 'ts-case-convert'

//* ---------------- BASE ---------------- *//
export const chargeTypeEnum = [
  'deposit',
  'balance',
  'refund',
  'trinity',
  'reftxn',
  'fabric',
  'parts',
  'shipping',
  'swatches',
] as const

//* ---------------- SCHEMAS ---------------- *//
export const creditCardSchema = z
  .object({
    card_type: z.string(),
    cardholder_name: z.string(),
    expiration_month: z.string(),
    expiration_year: z.string(),
    gateway_type: z.string(),
    is_primary: z.boolean(),
    last_4: z.string(),
    logo: z.string(),
    token: z.string(),
    zip_code: z.string().nullable(),
  })
  .transform(objectToCamel)

export const currencySchema = z.object({
  name: z.string(),
  symbol: z.string(),
  rate: z.string(),
})

export const baseChargeSchema = z.object({
  gateway: z.union([z.literal('braintree'), z.literal('payflow')]),
  charge_date: z.coerce.date(),
  charge_creation_date: z.coerce.date(),
  charge_amount: z.string(),
  charge_active: z.boolean(),
  dealer_order_id: z.number().nullable().optional(),
  card_type: z.string().nullable(),
  last_4: z.string().nullable(),
  charge_type: z.enum(chargeTypeEnum),
  transaction_type: z.string(),
  response_message: z.string().nullable(),
  currency_id: z.number(),
  id: z.number(),
  transaction_result_code: z.string().nullable(),
  merchant_initiated: z.boolean(),
  currency: currencySchema.optional(),
})

export const chargeSchema = baseChargeSchema.transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  namespace TrinityAPI {
    type CreditCardType = z.infer<typeof creditCardSchema>
    type CurrencyType = z.infer<typeof currencySchema>
    type ChargeType = z.infer<typeof chargeSchema>
  }
}
